import { i18next } from '@frontend/i18n';
import { formatTime } from '../../utils/get-event-accordion-body';
import { EventRenderer } from '../../utils/render-event';
import { AccordionEvent } from '../../utils/render-event-accordion';
import { EventBox } from '../event-renderer-item';
import { DialOptionBadge, FallbackChip } from '../fallback.component';

export const renderIVR: EventRenderer = (event, { callerName }) => {
  if (!('ivrEvent' in event)) return null;

  const { ivrMenuName, ivrMenuId, dtmfEvents } = event.ivrEvent;
  const createdAtTime = formatTime(event.createdAt);
  const hasFallback = event?.ivrEvent.dialOption === 'FALLBACK';
  const hasDTMFEvents = dtmfEvents && dtmfEvents.length > 0;

  const content = (
    <EventBox
      key={ivrMenuId}
      iconName='phone-tree'
      title={i18next.t('Phone Tree', { ns: 'calls' })}
      subtitle={ivrMenuName}
      endAdornment={createdAtTime}
      secondaryText={!hasDTMFEvents && i18next.t('No option dialed', { ns: 'calls' })}
      hideBoxShadow={hasDTMFEvents}
    />
  );

  return (
    <>
      {hasDTMFEvents ? (
        <AccordionEvent event={event} eventKey={`ivr-${event.ivrEvent.ivrMenuId}`} callerName={callerName}>
          {content}
        </AccordionEvent>
      ) : (
        content
      )}
      <div className='event-box-item' css={{ textAlign: 'center', position: 'relative' }}>
        {hasFallback && <FallbackChip />}
        {!!event.ivrEvent.dialOption && !hasFallback && <DialOptionBadge displayValue={event.ivrEvent.dialOption} />}
      </div>
    </>
  );
};
